<template>
  <div class="comment" v-bind:class="{ messagehidden: comment.is_hidden }" id="`loadableContent-comment-${this.comment.id}`" v-if="this.comment && this.comment.id">
    <div v-bind:class="getLinkedin ? 'content-linkedin' : getInstagram ? 'content-instagram' : 'content'">
     <!-- {{comment}}-->
     <div class="from-message">
      <div class="from" v-if="comment.from && (comment.from.name || comment.from.username)">{{ comment.from.name || comment.from.username }}
        <span class="autor-linkedin" v-if="page.network == 'linkedin' && page.name==comment.from.name">Auteur</span>
      </div>
      <!--<div class="message">{{ comment.message }}</div>-->
      <div class="message" v-html="colorizeBadWords(comment.message || comment.text)"></div>
      </div>
      <div class="attachment" v-if="comment.attachment">
        <img :src="comment.attachment.media.image.src" />
      </div> 
      <div class="date-linkedin" v-if="page.network == 'linkedin'">
        <Tooltip
            :text="dateFormat(comment.created_time)"
            position="top"
          >
            <span>{{ dateFromNow(comment.created_time) }}</span>
            &nbsp;
          </Tooltip>
      </div>
      <div class="more" v-if="page.network != 'instagram'">
        <vs-dropdown :vs-trigger-click="true">
          <vs-button class="btn-filter" type="filled" icon="more_horiz"></vs-button>
          <vs-dropdown-menu>
           <vs-dropdown-item v-if='(page.network == "facebook" && comment.can_hide == 1 && typeof comment.is_hidden != "undefined") || (page.network == "instagram" && page.name != comment.from.name)' @click.prevent="hideComment(comment.id, comment.is_hidden)">
              {{ (!inbox || !inbox.hide) ? $t('dash.button.hide.comment') : $t('dash.button.unhide.comment')}}
            </vs-dropdown-item>
            <vs-dropdown-item @click.prevent="deleteComment(comment.id)" class="delete-comment">
              {{$t('dash.button.delete.comment')}}
            </vs-dropdown-item>
            <vs-dropdown-item v-if="comment.is_hidden == 0 && !['instagram', 'linkedin'].includes(page.network) && !inbox" @click.prevent="blockUser(comment.from)" class="delete-comment">
              {{$t('dash.button.block.comment')}}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="more" v-if="page.network == 'instagram'">
        <vs-dropdown :vs-trigger-click="true">
          <vs-button class="btn-filter" type="filled" icon="more_horiz"></vs-button>
          <vs-dropdown-menu>
           <vs-dropdown-item v-if='(page.network == "facebook" && comment.can_hide == 1 && typeof comment.is_hidden != "undefined") || (page.network == "instagram" && page.name != comment.from.username)' @click.prevent="hideComment(comment.id, comment.is_hidden || comment.hidden)">
              {{ (!inbox || !inbox.hide) ? $t('dash.button.hide.comment') : $t('dash.button.unhide.comment')}}
            </vs-dropdown-item>
            <vs-dropdown-item @click.prevent="deleteComment(comment.id)" class="delete-comment">
              {{$t('dash.button.delete.comment')}}
            </vs-dropdown-item>
            <vs-dropdown-item v-if="comment.is_hidden == 0 && !['instagram', 'linkedin'].includes(page.network) && !inbox" @click.prevent="blockUser(comment.from)" class="delete-comment">
              {{$t('dash.button.block.comment')}}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
    <div :class="getLinkedin ? 'cta-linkedin' : getInstagram ? 'cta-instagram' : 'cta'">

      <div class="like" :class="[{'already': has_liked}]" @click="!has_liked && page.network != 'instagram'? likeComment() : ''">{{ getCountLikes }}{{$t('dash.label.fb.like')}}</div>
      <div v-if="page.network == 'linkedin'" style="height: 16px; border-left: 1px solid; color:#56687a;"></div>
      <div class="answer" @click="showInputComment = !showInputComment">{{$t('dash.label.fb.answer')}}</div>
       <span v-if="page.network == 'linkedin' && comment.comment_count" style="color:#56687a; padding-left: 0px !important; padding-right: 4px !important">·</span> 
      <div class="linkedin-comments-count" v-if="comment.comment_count && page.network == 'linkedin'"> {{comment.comment_count}} {{$t('dash.label.fb.comments')}} </div>
      <div class="date" v-if="page.network != 'linkedin' && page.network != 'instagram'">
        <Tooltip
            :text="dateFormat(comment.created_time)"
            position="top"
          >
            <span>{{ dateFromNow(comment.created_time) }}</span>
            &nbsp;
          </Tooltip>
      </div>
      <div class="date-instagram" v-if="page.network == 'instagram'">
        <Tooltip
          :text="dateFormat(comment.created_time)"
          position="top"
        >
          <span>{{ dateFromNow(comment.created_time) }}</span>
          &nbsp;
        </Tooltip>
      </div>
  </div>
    <!-- <div v-if="page.network == 'instagram' && comment.comments" class='instagram-answear'>
      <div style="width: 20px; border-bottom: 1px solid; color:#8e8e8e; margin-left: 26px; margin-bottom: 5px; margin-right: 5px"></div>  
      <div class="instagram-answear-text">{{$t('dash.div.answear.instagram')}}</div>
    </div> -->
  
    <div class="message" v-if="showInputComment">
    <message-comment 
        :node="comment" 
        :page="page"
        :inbox="inbox"
        v-on:getComments="getComments"
        @onSubmitComment="onSubmitComment"
      ></message-comment>
    </div>
     <ul v-if='(comment.comments || comment.replies) && (comment.comments || comment.replies).data && (comment.comments || comment.replies).data.length && !badWordsFeed' :style="{width: getLinkedin ? '130%' : '100%'}">
        <li v-for="(item, key) in (comment.comments || comment.replies).data" :key="key" :class="`comment-${key}`">
          <comment :comment="item" :page="page" :inbox="inbox"
          v-on:delete="deleteComment"
          v-on:hide="hideComment"
          v-on:block="blockUser"
          v-on:likeComment="likeCommentEvent"
          ></comment>
        </li>            
    </ul> 
  </div>
</template>

<script>
import moment from 'moment'
import Moderation from './../mixins/Moderation'
import Comment from './Comment.vue'
import MessageComment from './MessageComment'
import Tooltip from './tooltip/tooltipInit'



export default {
  name: 'comment',

  mixins: [Moderation],

  components: {
    Comment,
    MessageComment,
    Tooltip
  },

  props: {
    page: Object,
    comment: Object,
    badWordsFeed: Boolean,
    badWordList: Array,
    inbox: Object,
  },

  data() {
    return {
      showInputComment: false,
      badWords: []
    }
  },

  mounted(){
    moment.locale(this.$i18n.locale)
    if(this.badWordList && this.badWordList.length > 0)
      this.checkBadWords()
  },

  methods: {
    onSubmitComment(nodeId, message){
      this.$emit('onSubmitComment', nodeId, message)
      this.showInputComment = false
    },

    getBadWordsList(){
      return this.badWordList ? new RegExp(this.badWordList.join("|"), 'gi') : []
    },

    checkBadWords(){
      let found = (this.comment.message || this.comment.text).match(this.getBadWordsList())
      if (found) {
        this.badWords = found
        this.$emit('badWordsDetected', this.comment, found)
      }

      //under comments
      if(this.comment.comments && this.comment.comments.data)
        this.comment.comments.data.forEach(c => {
          found = c.message.match(this.getBadWordsList())
          if (found) {
            this.badWords = found
            this.$emit('badWordsDetected', c, found)
          }
        })
    },

    colorizeBadWords(message){
      return message.replace(this.getBadWordsList(), "<span class='bad-word'>$&</span>")
    },

    dateFromNow(date){
      if(this.page.network == 'linkedin' || this.page.network == 'instagram'){
        let temps = moment(date).fromNow(1)
        temps = temps.replace('heures', 'h')
        temps = temps.replace('minutes', 'm')
        temps = temps.replace('heure', 'h')
        temps = temps.replace('jours', 'j')
        temps = temps.replace('jour', 'j')
        temps = temps.replace('une', '1')
        temps = temps.replace('un', '1')
        temps = temps.replace('quelques secondes', '1s')
        temps = temps.replace(/\s/g, '')
        return temps
        }
        else
          return moment(date).fromNow(0)

    },

    dateFormat(date){
      return moment(date).local(this.$i18n.locale).format('LLL')
    },
    
    async hideComment(commentid, ishidden){
      console.log('entré dans hidecomment comment.vue')
      console.log("is_hidden :", ishidden)
      console.log("comment_id :", commentid)
      this.$emit('hide', commentid, ishidden)
    },

    async blockUser(commentfrom){
      console.log('comment vue :', commentfrom.id, commentfrom)
      this.$emit('block', commentfrom.id || commentfrom)
     // let status = await this.deleteNode(this.page, commentid)
    },

    async deleteComment(commentid){
      console.log('comment vue :', commentid)
      this.$emit('delete', commentid, this.badWordsFeed)
     // let status = await this.deleteNode(this.page, commentid)
    },

    getComments(){
      this.showInputComment = false
      this.$emit('getComments')
    },

    likeComment(){
      this.$emit('likeComment', this.inbox ? this.comment.id : this.comment)
    },

    likeCommentEvent(comment){
      this.$emit('likeComment', comment)
    },
  },

  computed: {
   getCountLikes() {
     if(this.page.network == 'linkedin')
      return this.comment.likesSummary ? (this.comment.likesSummary.totalLikes > 0 ? `(${this.comment.likesSummary.totalLikes}) ` : "")
                                       : (this.comment.likes && this.comment.likes > 0 ? `(${this.comment.likes}) ` : "")
     else if(this.page.network != 'instagram')
      return this.comment.like_count && this.comment.like_count > 0 ? `(${this.comment.like_count}) ` : ""
     else
      return this.comment.like_count && this.comment.like_count > 0 ? `${this.comment.like_count} ` : ""
   },
   getLinkedin()  {
     if(this.page.network == 'linkedin')
     return true
     else
     return false
   },
   getInstagram() {
     if(this.page.network == 'instagram')
      return true
    else
      return false
   },
   
   has_liked(){
     return this.comment && this.comment.likes && this.comment.likes.data && this.comment.likes.data.find(liker => liker.id == this.page.network_id) 
              ? true
              : false
   }
  },

  watch: {
    badWordList(){
      this.checkBadWords()
    }
  }
}    
</script>